import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user, loading } = useAuth();

  console.log("PrivateRoute =>", {
    isAuthenticated,
    user,
    loading,
    requiredRole
  });

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log("Redirecting: not authenticated");
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    console.log("Redirecting: role mismatch. Required:", requiredRole, "Got:", user?.role);
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
